module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ready),
      expression: "ready"
    }],
    attrs: {
      "to": _vm.$onduro.route('chats', _vm.channel.id)
    }
  }, [_c('div', {
    staticClass: "profile"
  }, [_c('gravatar', {
    attrs: {
      "email": _vm.gravatar
    },
    on: {
      "loaded": function($event) {
        _vm.ready = true
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "channel-list-details",
    class: {
      'unread': _vm.unreadCount > 0
    }
  }, [(!_vm.empty(_vm.lastChannel.lastChat)) ? _c('time', {
    attrs: {
      "datetime": _vm.lastChannel.lastChat.createdAt
    }
  }, [_vm._v(_vm._s(_vm.dateFormat('YYYY-MM-DD HH:mm:ss', _vm.lastChannel.lastChat.createdAt)))]) : _c('time', {
    attrs: {
      "datetime": _vm.channel.createdAt
    }
  }, [_vm._v(_vm._s(_vm.dateFormat('YYYY-MM-DD HH:mm:ss', _vm.channel.createdAt)))]), _vm._v(" "), _c('chat-bubble', {
    staticClass: "bubble--blue",
    attrs: {
      "count": _vm.unreadCount,
      "limit": "99"
    }
  }), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.channel.title))]), _c('br'), _vm._v(" "), (!_vm.empty(_vm.lastChannel.lastChat)) ? _c('small', {
    staticClass: "text-light"
  }, [(_vm.lastChannel.lastChat.mine) ? _c('b', [_vm._v(_vm._s(_vm.$t('text.you')) + ": ")]) : _vm._e(), _vm._v("\n                " + _vm._s(_vm.lastChannel.lastChat.message) + "\n            ")]) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6129179d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/global/ChannelListSingle.vue
// module id = 512
// module chunks = 234